import {
    DropdownMenu,
    DropdownMenuTrigger,
    DropdownMenuContent,
    DropdownMenuItem,
} from "@/components/ui/dropdown-menu"
import { ReactNode } from "react"
import { ChevronDown } from "lucide-react"

const InlineWrapper = ({ children }: { children: ReactNode }) => {

    return (
        <>
            <div className="relative w-full max-w-md rounded-lg bg-[#f2f4f8] flex flex-col p-2">
                <div className="p-4 space-y-4 border border-slate-200 shadow-md rounded-md">
                    {/* Candidate Status */}
                    <div className="space-y-2">
                        <p className="text-xs font-semibold text-slate-500 uppercase">
                            Candidate Status
                        </p>

                        <DropdownMenu>
                            <DropdownMenuTrigger className="w-full flex items-center justify-between px-4 py-3 border border-slate-300 rounded-md bg-white text-sm">
                                Offer Accepted
                                <ChevronDown className="h-4 w-4 text-slate-500" />
                            </DropdownMenuTrigger>
                            <DropdownMenuContent container={document.body} className="w-48 bg-white border border-slate-200 shadow-md rounded-md p-1 mt-2">
                                <DropdownMenuItem>Offer Accepted</DropdownMenuItem>
                                <DropdownMenuItem>Offer Rejected</DropdownMenuItem>
                                <DropdownMenuItem>Offer On Hold</DropdownMenuItem>
                                <DropdownMenuItem>Offer Sent</DropdownMenuItem>
                            </DropdownMenuContent>
                        </DropdownMenu>
                    </div>
                    <div>
                        {children}
                    </div>
                </div>

                <div className="mt-4">
                    <h3>Activity</h3>
                    <ul className="list-disc list-inside text-sm text-slate-600">
                        <li className="mb-1">2024-06-01: Candidate accepted the offer.</li>
                        <li className="mb-1">2024-05-28: Offer letter sent to candidate.</li>
                        <li className="mb-1">2024-05-25: HR reviewed candidate profile.</li>
                    </ul>
                </div>
            </div>

        </>
    )
}

export default InlineWrapper
